function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { connect } from "react-redux";
import { Button } from "../../../general/Buttons";
import styled from 'styled-components';
import InlineToggleOpenTrigger from "./InlineToggleOpenTrigger";
import InlineToggleActionForm from "./InlineToggleActionForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
const StyledButton = styled(Button)`
  box-shadow: none !important;
`;

class InlineToggleAction extends React.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      formOpen: false,
      text: ""
    });

    _defineProperty(this, "openForm", () => {
      this.setState({
        formOpen: true
      });
    });

    _defineProperty(this, "closeForm", e => {
      this.setState({
        formOpen: false
      });
    });

    _defineProperty(this, "handleInputChange", e => {
      this.setState({
        text: e.target.value
      });
    });

    _defineProperty(this, "handleAction", () => {
      const {
        text
      } = this.state;

      if (this.props.allowEmpty) {
        this.props.handleAction(text);
      } else {
        if (!!text) {
          this.props.handleAction(text);
        } else {
          this.setState({
            text: this.props.value
          });
        }
      }
    });
  }

  componentDidMount() {
    if (!!this.props.value) {
      this.setState({
        text: this.props.value
      });
    }
  }

  render() {
    const {
      text
    } = this.state;
    return this.state.formOpen ? /*#__PURE__*/React.createElement(InlineToggleActionForm, {
      text: text,
      onChange: this.handleInputChange,
      closeForm: this.closeForm,
      placeholder: this.props.placeholder,
      required: this.props.required
    }, /*#__PURE__*/React.createElement(StyledButton, {
      color: 'info',
      size: 'sm',
      onClick: this.handleAction
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faSave
    }))) : /*#__PURE__*/React.createElement(InlineToggleOpenTrigger, {
      onClick: this.openForm
    }, this.props.trigger);
  }

}

export default connect(null, {})(InlineToggleAction);